
import { Component, Prop, Vue } from "vue-property-decorator";
import { Mutation } from "vuex-class";
const namespace = "StudioModule";

@Component
export default class ColorLabel extends Vue {
  @Prop() private color!: string;
  @Prop() private note!: string;
  @Mutation('setSelectedColor', {namespace}) private setSelectedColor!: (value:string) => any;
}

